/*!

  =========================================================
  * Vue Paper Dashboard 2 PRO - V2.4.0
  =========================================================

  * Product Page: https://www.creative-tim.com/product/vue-paper-dashboard-2-pro
  * Available with purchase of license from https://www.creative-tim.com/product/vue-paper-dashboard-2-pro
  * Copyright 2019 Creative Tim (https://www.creative-tim.com)
  * License Creative Tim (https://www.creative-tim.com/license)

  =========================================================

*/

import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import { store } from './store';
import axios from 'axios';

// Pretty print ENV variables
//Object.keys(process.env).forEach(key => {
  //console.log(`${key}: ${process.env[key]}`)
//})

// Access environment variables
const API_BASE_URL = process.env.VUE_APP_BASE_URL,
IS_PROD = process.env.VUE_APP_PROD === '1',
REPO = process.env.VUE_APP_REPO;

//console.log('API Base URL:', API_BASE_URL)
//console.log('Is Production:', IS_PROD)
//console.log('Repository:', REPO)

// Axios setup
axios.defaults.withCredentials = true
axios.defaults.baseURL = API_BASE_URL;
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.timeout = 3600000;
axios.defaults.validateStatus = () => { return true };

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar';

// router setup
import routes from './routes/routes'

// library imports
import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'
import sidebarLinks from './sidebarLinks'
import './registerServiceWorker'

// plugin setup
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
locale.use(lang)

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})
initProgress(router);

const tienda = store;
router.beforeResolve((to, from, next) => {

  //console.log({to, from, next})

  if (to.name == 'NewPass') {
    const resetDict = {}, resetKeys = Object.keys(to.query);
    resetDict.name = to.name

    //console.log({resetKeys})

    // Requires credentials to proceed properly
    if (resetKeys.length) {
      for (let r = 0; r < resetKeys.length; r++) {
        const tmpKey = resetKeys[r],
        tmpVal = to.query[tmpKey];

        //console.log({tmpKey, tmpVal})

        resetDict[tmpKey] = tmpVal

        //console.log({resetDict})
      }
    }

    //console.log({resetDict})

    if (!tienda.reset_pass) tienda.reset_pass = resetDict
    //if (!tienda.irisData) tienda.irisData = true
  }

  if (to.name !== 'Login' && !tienda.irisData) next({ name: 'Login' })
  else next()
})

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router,
  mounted() {
    // Prevent back/forth via history
    window.addEventListener('popstate', this.handlePopState);

    // Block touchpad swipes
    window.addEventListener('touchmove', this.preventSwipe, { passive: false });

    // Set initial history state
    history.pushState(null, null, window.location.href);
  },
  methods: {
    handlePopState(event) {
      //console.log('Popstate triggered', event);
      //console.log('Current Route:', this.$route.path);
      //console.log('Last Route:', this.lastRoute);

      // Check if this is an unintended navigation (back/forth)
      if (event.state && event.state.path !== this.$route.path) {
        // Block unintended back/forth by reverting to last intended route
        history.pushState({ path: this.lastRoute }, null, this.lastRoute);
        // Optional: Notify user (if using Element UI)
        // this.$message.warning('Back/forward navigation is disabled');
      } else {
        // Update lastRoute for legitimate navigation
        this.lastRoute = this.$route.path;
      }
    },
    preventSwipe(event) {
      const touch = event.touches[0];

      if (Math.abs(touch.pageX - (this.lastX || touch.pageX)) > 10) {
        event.preventDefault(); // Block horizontal swipes
      }
      this.lastX = touch.pageX;
    },
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopState);
    window.removeEventListener('touchmove', this.preventSwipe);
  },
});

// Disable overscroll
const style = document.createElement('style');
style.textContent = 'html, body { overscroll-behavior-x: none; overscroll-behavior-y: none; }';
document.head.appendChild(style);
